var __WEBPACK_NAMESPACE_OBJECT__ = VueI18n;